(() => {
  'use strict';
  const status = message => { const el = document.querySelector('[data-vs-status]'); if (el) el.textContent = message; };
  async function jsonRequest(url, body) {
    const response = await fetch(url, { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify(body), signal: AbortSignal.timeout(20000) });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'We couldn’t update your cart. Please try again.');
    return data;
  }
  let cartBusy = false;
  async function changeQuantity(row, quantity) {
    if (cartBusy) return;
    if (!Number.isSafeInteger(quantity) || quantity < 0) return;
    const region = document.querySelector('[data-vs-cart-region]');
    const input = row.querySelector('input[name="updates[]"]');
    const focusId = input.id;
    const oldValue = input.defaultValue;
    const controls = [...region.querySelectorAll('button,input')];
    const error = region.querySelector('[data-vs-cart-error]');
    cartBusy = true;
    region.setAttribute('aria-busy', 'true');
    controls.forEach(control => { control.disabled = true; });
    if (error) error.hidden = true;
    status('Updating your cart.');
    try {
      const cartPath = document.querySelector('#vs-cart-form').getAttribute('action');
      await jsonRequest(cartPath.replace(/\/$/, '') + '/change.js', { id: row.dataset.lineKey, quantity });
      const response = await fetch(location.href, { credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(20000) });
      if (!response.ok) throw new Error('Your cart changed. Refresh this page to see the latest total.');
      const page = new DOMParser().parseFromString(await response.text(), 'text/html');
      const replacement = page.querySelector('[data-vs-cart-region]');
      if (!replacement) throw new Error('Your cart changed. Refresh this page to see the latest total.');
      region.replaceWith(replacement);
      const header = document.querySelector('.vs-cart-link');
      const newHeader = page.querySelector('.vs-cart-link');
      if (header && newHeader) header.replaceWith(newHeader);
      const nextFocus = document.getElementById(focusId) || replacement.querySelector('h1');
      if (nextFocus) { if (nextFocus.tagName === 'H1') nextFocus.tabIndex = -1; nextFocus.focus({ preventScroll: true }); }
      status('Your cart has been updated.');
    } catch (failure) {
      input.value = oldValue;
      if (error) { error.textContent = failure.message || 'Please try again.'; error.hidden = false; }
      status('Your cart could not be updated. Please try again.');
    } finally {
      cartBusy = false;
      region.removeAttribute('aria-busy');
      controls.forEach(control => { control.disabled = false; });
    }
  }
  document.addEventListener('click', event => {
    const quantityButton = event.target.closest('[data-vs-quantity]');
    if (quantityButton) { const row = quantityButton.closest('[data-vs-line]'); const input = row.querySelector('input[name="updates[]"]'); const step = Number(input.step) || 1; const value = Math.max(0, Number(input.value) + Number(quantityButton.dataset.vsQuantity) * step); if (input.max && value > Number(input.max)) { status('The maximum available quantity has been reached.'); return; } changeQuantity(row, value); }
    const remove = event.target.closest('[data-vs-remove]');
    if (remove && !event.metaKey && !event.ctrlKey && !event.shiftKey) { event.preventDefault(); changeQuantity(remove.closest('[data-vs-line]'), 0); }
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-vs-line] input[name="updates[]"]') && event.target.checkValidity()) changeQuantity(event.target.closest('[data-vs-line]'), Number(event.target.value));
  });
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!form.matches('.vs-add-form')) return;
    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    const error = form.querySelector('.vs-form-error');
    if (button.disabled) return;
    const fields = new FormData(form);
    const controls = [...form.querySelectorAll('input,button')].map(control => [control, control.disabled]);
    const previousLabel = button.innerHTML;
    form.dataset.submitting = 'true';
    controls.forEach(([control]) => { control.disabled = true; });
    button.textContent = 'Adding to your cart…';
    if (error) error.hidden = true;
    try {
      await jsonRequest(new URL(form.action, location.href).pathname.replace(/\/$/, '') + '.js', { id: fields.get('id'), quantity: Number(fields.get('quantity') || 1) });
      status('Added to your cart.');
      location.assign(fields.get('return_to') || '/cart');
    } catch (failure) {
      if (error) { error.textContent = failure.message || 'Please try again.'; error.hidden = false; }
      delete form.dataset.submitting;
      controls.forEach(([control, disabled]) => { control.disabled = disabled; });
      button.innerHTML = previousLabel;
    }
  });
})();
